const LOG_PREFIX = '[GET - Priority Level Fields]';

const constants = {
  LOG_PREFIX,
};

export default constants;
